import { Text } from "@chakra-ui/react";

export const TitleWrapper = ({ children }: { children: React.ReactNode }) => (
  <Text as="h4" fontWeight="500" fontSize={"18.4px"} mb={4}>
    {children}
  </Text>
);
